import { render } from "./BasicTitle.vue?vue&type=template&id=7556815b&scoped=true"
import script from "./BasicTitle.vue?vue&type=script&lang=js"
export * from "./BasicTitle.vue?vue&type=script&lang=js"

import "./BasicTitle.vue?vue&type=style&index=0&id=7556815b&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src766051562/src/medoor-medical-records/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7556815b"]])

export default __exports__